<template>
  <vs-row>
    <vs-row vs-justify="space-between" class="my-5 mx-4">
      <vs-dropdown>
        <vs-button
          id="bgDarkAction"
          class="pr-4 font-semibold"
          type="filled"
          icon="expand_more"
          icon-after
          >Action</vs-button
        >

        <vs-dropdown-menu class="accountsDropdown">
          <vs-dropdown-item @click="showMergePopUp"> Merge </vs-dropdown-item>
          <vs-dropdown-item @click="confirmDelete = true">
            Delete
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <input
        maxLength="30"
        type="text"
        name="search"
        class="search px-4 w-1/3 py-3 shadow-lg"
        placeholder="Search..."
        @input="getPendingCards('search')"
        v-model="search"
      />
    </vs-row>
    <vs-row class="tblBgClrPending shadow-lg mx-4">
      <vs-table
        multiple
        v-model="selected"
        :max-items="itemsPerPage"
        :data="pendingCardsList"
        class="w-full"
        hoverFlat
      >
        <template slot="thead">
          <vs-th sort-key="name">USER</vs-th>
          <vs-th sort-key="category">ISSUER</vs-th>
          <vs-th sort-key="popularity">CARD NAME</vs-th>
          <vs-th sort-key="order_status">DATE CREATED</vs-th>
          <vs-th sort-key="order_status">STATUS</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td @click.native.stop="reviewData(tr)">
                <p
                  class="font-medium"
                  :key="index"
                  v-for="(profile, index) in tr.profiles"
                >
                  {{
                    profile.profile && profile.profile.user
                      ? index > 0 &&
                        tr.profiles[index - 1].profile.user._id ===
                          profile.profile.user._id
                        ? ""
                        : profile.profile.user.firstname +
                          " " +
                          profile.profile.user.lastname
                      : "Not Available"
                  }}
                </p>
                <!-- <h6 v-if="tr.profiles.length > 3">...</h6> -->
              </vs-td>

              <vs-td @click.native.stop="reviewData(tr)">
                <vs-row v-if="tr.issuerName">
                  <p class="font-medium mt-1">
                    {{ tr.issuerName ? tr.issuerName : "Not Available" }}
                  </p>
                  <vs-chip color="primary" class="ml-2"> New </vs-chip>
                </vs-row>
                <p class="font-medium" v-else>
                  {{
                    tr.issuerId && tr.issuerId.name
                      ? tr.issuerId.name
                      : "Not Available"
                  }}
                </p>
              </vs-td>

              <vs-td @click.native.stop="reviewData(tr)">
                <p class="font-medium">
                  {{ tr.cardName ? tr.cardName : "Not Available" }}
                </p>
              </vs-td>

              <vs-td @click.native.stop="reviewData(tr)">
                <p class="font-medium">{{ tr.date | formatDate }}</p>
              </vs-td>

              <vs-td @click.native.stop="reviewData(tr)">
                <p class="font-medium">Pending</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <vs-row
        class="my-6 w-full"
        vs-justify="center"
        v-if="pendingCardsList && pendingCardsList.length > 0"
      >
        <div style="width: max-content">
          <vs-pagination
            :total="totalPages"
            v-model="pageIndex"
            @change="getPendingCards"
            v-show="cardListHasData"
          ></vs-pagination>
        </div>
      </vs-row>
      <vs-popup
        class="holamundo"
        title="Merge"
        :active.sync="showMerge"
        id="merge"
      >
        <vs-row>
          <div class="verticalHeight w-full p-4">
            <vs-row>
              <div class="addCardFont font-semibold ml-3">Issuer</div>
              <vs-input
                :danger="errors.issuerName.success"
                :danger-text="errors.issuerName.msg"
                class="w-full p-2 pt-4"
                @click="handleFilter"
                v-on-clickaway="closeColorList"
                v-model="mergeSelectedIssuer.name"
                readonly
                @change="getCardsList"
                placeholder="Select an Issuer"
              />
              <div class="dropdown-content p-3" v-show="toggleColorList">
                <div
                  class="colorItemContainer"
                  @click="setIssuer(issuer)"
                  :key="index"
                  v-for="(issuer, index) in issuersList"
                >
                  <div
                    class="colorIconStyle"
                    :style="{ 'background-color': issuer.color }"
                  ></div>
                  <span class="colorTextStyle">{{ issuer.name }}</span>
                </div>
              </div>
            </vs-row>
            <vs-row>
              <div class="addCardFont font-semibold ml-3 mt-3">Card</div>
              <vs-input
                :danger="errors.cardName.success"
                :danger-text="errors.cardName.msg"
                class="w-full p-2 pt-4"
                @click="handleCardFilter"
                v-on-clickaway="closeCardsList"
                v-model="mergeSelectedCard.name"
                readonly
                :placeholder="
                  mergeSelectedIssuer.name
                    ? 'Select a card'
                    : 'Please select an Issuer first'
                "
              />
              <div class="dropdown-content p-3" v-show="toggleCardsList">
                <div
                  class="colorItemContainer"
                  @click="mergeSelectedCard = card"
                  :key="index"
                  v-for="(card, index) in cardsList"
                >
                  <div
                    class="colorTextStyle p-1 pl-3"
                    style="position: relative !important"
                  >
                    {{ card.name }}
                  </div>
                </div>
              </div>
            </vs-row>
            <vs-row vs-justify="center" class="mt-5">
              <vs-button @click="mergeRequests">Merge</vs-button>
            </vs-row>
          </div>
        </vs-row>
        <vs-row> </vs-row>
      </vs-popup>
    </vs-row>
    <vs-popup
      class="holamundo"
      title="Status"
      :active.sync="showDeleteStatus.status"
    >
      <h5>
        {{ showDeleteStatus.msg }}
      </h5>
    </vs-popup>
    <vs-popup class="holamundo" title="Status" :active.sync="confirmDelete">
      <h5>Are you sure that you want to delete?</h5>
      <vs-row vs-justify="flex-end">
        <vs-button @click="deleteRequests" class="mr-4">Yes</vs-button>
        <vs-button @click="confirmDelete = false">No</vs-button>
      </vs-row>
    </vs-popup>
  </vs-row>
</template>

<script>
import { MenuIcon, XIcon } from "vue-feather-icons";
import { mixin as clickaway } from "vue-clickaway";

import { validateIssuerName, validateCardName } from "@/views/admin/validation";
import { genericErrorMessage, toast } from "@/keys/toast-messages";

import EventBus from "@/event-bus.js";

export default {
  components: {
    MenuIcon,
    XIcon,
  },
  mixins: [clickaway],
  data() {
    return {
      timer: false,
      confirmDelete: false,

      showMerge: false,
      mergeSelectedIssuer: "",
      mergeSelectedCard: "",

      toggleColorList: false,
      toggleCardsList: false,

      issuersList: [],
      cardsList: [],

      selected1: 1,
      selected2: 1,
      selected3: 1,
      selected4: 1,
      options1: [
        { text: "Last 7 days", value: 1 },
        { text: "Last 1 Month", value: 2 },
        { text: "Last 6 Months", value: 3 },
      ],

      pendingCardsList: [],
      search: "",
      cardListHasData: true,
      pageIndex: 1,
      totalPages: 1,

      selected: [],
      itemsPerPage: 6,

      showDeleteStatus: {
        msg: "",
        status: false,
      },

      errors: {
        issuerName: {
          msg: "",
          success: false,
        },
        cardName: {
          msg: "",
          success: false,
        },
      },
      validateIssuerName,
      validateCardName,
      genericErrorMessage,
      toast,
    };
  },
  methods: {
    setIssuer(issuer) {
      this.mergeSelectedIssuer = issuer;
      this.mergeSelectedCard = "";
    },
    closeColorList() {
      this.toggleColorList = false;
      this.getCardsList();
    },
    closeCardsList() {
      this.toggleCardsList = false;
    },
    async handleFilter() {
      if (this.issuersList.length > 0) {
        this.toggleColorList = true;
      }
      this.getIssuers();
    },
    async handleCardFilter() {
      if (this.cardsList.length != 0) {
        this.toggleCardsList = true;
      } else {
        this.toggleCardsList = false;
      }
    },

    showMergePopUp() {
      this.showMerge = true;
      this.mergeSelectedIssuer = "";
      this.mergeSelectedCard = "";
      this.issuersList = [];
      this.cardsList = [];
    },
    reviewData(data) {
      data.id = data._id;
      data.issuerName = data.issuerName ? data.issuerName : data.issuerId.name;
      this.$router.push({ name: "review-card", params: data });
    },
    async deleteRequests() {
      this.confirmDelete = false;
      let requestIds = [];
      await this.selected.forEach(function (element, index) {
        requestIds.push(element._id);
      });

      if (this.selected.length == 0) {
        this.showDeleteStatus = {
          msg: "Please select atleast one request to delete",
          status: true,
        };
      } else {
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        this.showDeleteStatus = {
          msg: "",
          status: false,
        };
        return new Promise((resolve, reject) => {
          this.$axios
            .post(
              this.$ApiKeys.BASE_URL + this.$EndPoints.DeleteRequests,
              {
                requestId: requestIds,
              },
              {
                headers: {
                  Authorization: this.$localStorage.get("token"),
                },
              }
            )
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success == true) {
                this.showDeleteStatus = {
                  msg: res.data.data.message,
                  status: true,
                };
                await this.getPendingCards();
                this.$root.$emit("updateApprovals", {});
                this.selected = [];
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              if (e.response.data.errors.cardId) {
                this.showDeleteStatus = {
                  msg: e.response.data.errors.userId,
                  status: true,
                };
              } else {
                this.showDeleteStatus = {
                  msg: "",
                  status: false,
                };
                if (e.response.status !== 401) {
                  this.toast(this.genericErrorMessage());
                }
              }
            });
        });
      }
    },
    getPendingCards(name) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.selected = [];
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise(async (resolve, reject) => {
          await this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.PendingCards, {
              params: {
                searchquery: this.search,
                page: name == "search" ? 1 : this.pageIndex,
                limit: this.itemsPerPage,
              },
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            })
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                this.$root.$emit("updateApprovals", {});
                if (name == "search") {
                  this.pageIndex = 1;
                }
                this.totalPages = res.data.pageCount;
                resolve(
                  (this.pendingCardsList = res.data.data),

                  (this.cardListHasData = true)
                );

                // let users = [], i = 0;
                // this.pendingCardsList.forEach(element => {
                //     console.log('profiles length is: ',element.profiles)
                //     element.profiles.slice(0,3).forEach(profile => {
                //         let { user } = profile.profile;
                //         users[i++] = {
                //             _id: user._id,
                //             firstname: user.firstname,
                //             lastname: user.lastname
                //         }
                //     })
                // })
                // console.log('users before: ',users)
                // users = users.reduce((seed, current) => {
                //     return Object.assign(seed, {
                //         [current._id]: current
                //     });
                // }, {});
                // console.log('users after: ',users)
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              if (e.response.status == 404) {
                this.cardListHasData = false;
                this.pendingCardsList = [];
              }
              if (e.response.status !== 401 && e.response.status !== 404) {
                this.toast(this.genericErrorMessage());
              }
            });
        });
      }, 500);
    },
    getIssuers() {
      if (this.issuersList.length == 0) {
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise(async (resolve, reject) => {
          await this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.IssuerColors, {
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            })
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                resolve(
                  (this.issuersList = res.data.data),
                  (this.toggleColorList = true)
                );
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
            });
        });
      }
    },
    getCardsList() {
      if (this.mergeSelectedIssuer.name) {
        // this.$vs.loading({
        //     background: 'rgba(1,2,3,.2)'
        // });
        return new Promise(async (resolve, reject) => {
          await this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetIssuerCards, {
              params: {
                issuerId: this.mergeSelectedIssuer._id,
              },
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            })
            .then(async (res) => {
              if (res.data.success) {
                resolve((this.cardsList = res.data.data));
              } else {
                this.toast(this.genericErrorMessage());
              }
              // this.$vs.loading.close();
            })
            .catch((e) => {
              // this.$vs.loading.close();
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
            });
        });
      }
    },
    async mergeRequests() {
      this.validateIssuerName(
        this.mergeSelectedIssuer.name ? this.mergeSelectedIssuer.name : ""
      );
      this.validateCardName(
        this.mergeSelectedCard.name ? this.mergeSelectedCard.name : ""
      );

      if (
        this.errors.issuerName.success == false &&
        this.errors.cardName.success == false
      ) {
        let cardId = this.mergeSelectedCard._id;
        let requestIds = [];
        let profiles = [];
        await this.selected.forEach(async function (item, index) {
          await requestIds.push(item._id);
          await item.profiles.forEach(async function (element, index) {
            profiles.push(element);
          });
        });

        return new Promise((resolve, reject) => {
          this.$axios
            .post(
              this.$ApiKeys.BASE_URL + this.$EndPoints.MergeRequests,
              {
                profiles: profiles,
                requestId: requestIds,
                cardId: cardId,
              },
              {
                headers: {
                  Authorization: this.$localStorage.get("token"),
                },
              }
            )
            .then(async (res) => {
              if (res.data.success) {
                this.getPendingCards();
                this.showMerge = false;
                if (res.data.data.card) {
                  this.showDeleteStatus = {
                    msg: res.data.data.card,
                    status: true,
                  };
                } else {
                  this.showDeleteStatus = {
                    msg: "",
                    status: false,
                  };
                }
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.showMerge = false;
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
              // console.log("Error in mergeReuests: ",e);
            });
        });
      }
    },
  },
  created() {
    EventBus.$emit("resetToggleGroup", true);
    this.getPendingCards();
  },
};
</script>

<style>
@import "./style.css";
</style>
